import { Button, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faUpload } from "@fortawesome/free-solid-svg-icons";
import TableHolidays from "../../components/table/TableHolidays";
import { useState } from "react";
import ModalHolidayReferences from "../../components/modal/ModalHolidayReferences";

import { tr } from "../../i18n";
const TabHoliday = () => {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(0);

  return (
    <>
      <Row className="mt-3">
        <Col lg={12} className="mb-4 d-flex gap-3 justify-content-end">
          {/* Tombol Import dari References */}
          <Button
            variant="outline-primary"
            className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm"
            onClick={() => setShowModal(true)}
          >
            <FontAwesomeIcon icon={faUpload} />
            {tr("attendance:import_from_references")}
          </Button>

          {/* Tombol Add Holiday */}
          <Link
            to="/holiday/form"
            className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm fw-small"
          >
            <FontAwesomeIcon icon={faPlus} />
            {tr("attendance:add_holiday")}
          </Link>
        </Col>

        <Col lg={12}>
          <TableHolidays refresh={reload} />
        </Col>
      </Row>
      <ModalHolidayReferences
        show={showModal}
        onClose={() => setShowModal(false)}
        onSuccess={() => setReload((prev) => prev + 1)}
      />
    </>
  );
};

export default TabHoliday;
